import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import moment from 'moment';
import { storage, auth } from "../../helpers/Firebase";
import { UPLOAD_PATENT_SET } from "../actions";
import { uploadPatentSetSuccess, uploadPatentSetError } from "./actions";

const onUploadAsync = async (file) => {
  var user = await auth.currentUser;
  var storageRef = storage.ref()
  return await new Promise((success, reject) => {
    let now = moment();
    let filename = `${now.format("x")}_${Math.ceil(Math.random() * (1000 - 0) + 0)}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
    var uploadPatentTask = storageRef.child(user.uid+'/xmarket/' + filename).put(file);
    uploadPatentTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/delivery_file/' })
    }, 
    function() {
      uploadPatentTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
        success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/delivery_file/'});
      });
    });
  });
};

function* onUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onUploadAsync, file);
    if(response.message ==='success'){
      yield put(uploadPatentSetSuccess(response));
    }
    else{
      yield put(uploadPatentSetError(response));
    }
  } catch (error) {
    yield put(uploadPatentSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export function* watchUpload() {
  yield takeEvery(UPLOAD_PATENT_SET, onUpload);
}

export default function* rootSaga() {
  yield all([fork(watchUpload)]);
}
